import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, GET_MANUFACTURER_SUBMISSION } from "@/graphql";

export const manufacturerSubmissionApi = createApi({
  reducerPath: "api/manufacturer-submission",
  baseQuery,
  endpoints: (builder) => ({
    getManufacturerSubmission: builder.query<
      ManufacturerSubmissionData[],
      {
        clientId?: string;
        tenantId?: string;
        manufacturerId: string;
      }
    >({
      query: (variables) => ({
        document: GET_MANUFACTURER_SUBMISSION,
        variables: { ...variables },
      }),
      transformResponse: (response: ManufacturerSubmissionResponse) => {
        return response.getManufacturerSubmission
          ?.data as ManufacturerSubmissionData[];
      },
    }),
  }),
});

export const { useLazyGetManufacturerSubmissionQuery, useGetManufacturerSubmissionQuery } =
  manufacturerSubmissionApi;
